export default __webpack_public_path__ + "static/media/noResultsDocuments.35c31fbe.svg";